import Vue from 'vue'
import Vuex from 'vuex'

import Authentication from './authentication'
import Favorites from './favorites'
import Messages from './messages'
import Region from './region'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Authentication,
    Favorites,
    Messages,
    Region,
  },
})
